export const ORGVDC = "ORGANIZATIONVDC"